import Phaser from "phaser";

import StateMachine from "../utils/state-machine";

const scoreByItems = {
    diamond: 50,
    chest: 500,
    life: 0,
    star: 25,
    watch: 100,
    coin: 25
}

class c  {

    b = {
        a: 0,
        d: 0,
        c: 0,
        e: 0,
        f: 0,
    }

    constructor() { this.e = this.b }

    r = () => { this.e = this.b }

    f = (a, c) =>
    {
        if(a === "diamond")
        {
            this.e.a+= c;
        }

        if(a === "chest")
        {
            this.e.d+= c;
        }

        if(a === "star")
        {
            this.e.c+= c;
        }

        if(a === "watch")
        {
            this.e.e+= c;
        }

        if(a === "coin")
        {
            this.e.f+= c;
        }
    }
}

class Hero extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y) {
        super(scene, x, y, `hero-${scene.selectedCat}-sheet`, 0)

        scene.add.existing(this)
        scene.physics.add.existing(this)

        this.anims.play(`hero-${scene.selectedCat}-running`)

        this.body.setCollideWorldBounds(true)
        this.body.setSize(90, 160)
        this.body.setOffset(60, 44)
        this.body.setMaxVelocity(800, 800)
        this.body.setDragX(1024)

        this.keys = scene.cursorKeys
        this.input = {}

        this.miscControllerVars = {}
        this.hasBeenHit = false

        this.setupAnimations()
        this.setupMovement()

        this.a = new c()

        // emit events on world bounds
        this.body.onWorldBounds = true

        // for locking update framerate
        this.frameTime = 0
        this.lives = 5
        scene.updateLives(this.lives)


    }

    setDidTrampolineJump(value=true) {
        this.miscControllerVars.didTrampolineJump = value
    }
    getDidTrampolineJump() {
        let didTrampolineJump = this.miscControllerVars.didTrampolineJump
        this.miscControllerVars.didTrampolineJump = false
        return didTrampolineJump
    }

    ts = 0

    setupAnimations() {

        this.ts = Math.round((new Date()).getTime() / 1000)

        this.animState = new StateMachine({
            init: 'idle',
            transitions: [
                { name: 'idle', from: ['falling', 'running', 'pivoting'], to: 'idle' },
                { name: 'run', from: ['falling', 'idle', 'pivoting'], to: 'running' },
                { name: 'pivot', from: ['falling', 'running'], to: 'pivoting' },
                { name: 'jump', from: ['idle', 'running', 'pivoting'], to: 'jumping' },
                { name: 'flip', from: ['jumping', 'falling'], to: 'flipping' },
                { name: 'fall', from: ['idle', 'running', 'pivoting', 'jumping', 'flipping'], to: 'falling' },
                { name: 'die', from: '*', to: 'dead' },
            ],
            methods: {
                onEnterState: (lifecycle) => {
                    this.anims.play(`hero-${this.scene.selectedCat}-` + lifecycle.to)
                }
            }
        })

        this.animPredicates = {
            idle: () => {
                return this.body.onFloor() && this.body.velocity.x === 0
            },
            run: () => {
                return this.body.onFloor() && Math.sign(this.body.velocity.x) === (this.flipX ? -1 : 1)
            },
            pivot: () => {
                return this.body.onFloor() && Math.sign(this.body.velocity.x) === (this.flipX ? 1 : -1)
            },
            jump: () => {
                return this.body.velocity.y < 0
            },
            flip: () => {
                return this.body.velocity.y < 0 && this.moveState.is('flipping')
            },
            fall: () => {
                return this.body.velocity.y > 0
            }
        }
    }
    handleSpikeCollision = () => {
        this.takeHit()
    }
    setupMovement() {
        this.moveState = new StateMachine({
            init: 'standing',
            transitions: [
                { name: 'trampolinejump', from: ['jumping', 'flipping', 'falling', 'standing', 'trampolinejumping'], to: 'trampolinejumping' },
                { name: 'jump', from: 'standing', to: 'jumping' },
                { name: 'flip', from: 'jumping', to: 'flipping' },
                { name: 'fall', from: 'standing', to: 'falling' },
                { name: 'touchdown', from: ['jumping', 'flipping', 'falling', 'trampolinejumping'], to: 'standing' },
                { name: 'die', from: ['jumping', 'flipping', 'falling', 'standing', 'trampolinejumping'], to: 'dead' }
            ],
            methods: {
                onEnterState: (lifecycle) => {
                    // console.log(lifecycle)
                },
                onJump: () => {
                    this.body.setVelocityY(-800)
                    this.scene.jumpSound.play()
                },
                onFlip: () => {
                    this.body.setVelocityY(-800)
                },
                onDie: () => {
                    this.body.allowDrag = false
                    this.body.setVelocity(this.flipX ? 400 : -400, -800)
                    this.body.setAcceleration(0)
                },
                onTrampolinejump: () => {
                    let afterKillingEnemy = false
                    if (!this.isKillingEnemy) {
                        this.scene.trampolineJumpSound.play()
                        this.body.setMaxVelocityY(1200)
                        this.body.setVelocityY(-1200)
                        this.body.allowGravity = false
                    } else {
                        afterKillingEnemy = true
                        this.body.setVelocityY(-500)
                    }
                    
                    setTimeout(() => {
                        try {
                            if (!afterKillingEnemy) {
                                this.body.setMaxVelocityY(800)
                                this.body.setVelocityY(-800)
                                this.body.allowGravity = true
                            }
                        } catch (e) {
                            console.warn(e)
                        }
                        // if (!afterKillingEnemy) {
                        //     this.body.setMaxVelocityY(800)
                        //     this.body.setVelocityY(-800)
                        //     this.body.allowGravity = true
                        // }
                    }, 500)
                }
            }
        })

        this.movePredicates = {
            jump: () => {
                return this.input.didPressJump
            },
            flip: () => {
                return false;
                // return this.input.didPressJump
            },
            fall: () => {
                return !this.body.onFloor()
            },
            touchdown: () => {
                return this.body.onFloor()
            },
            trampolinejump: () => {
                return this.input.didTrampolineJump
            }
        }
    }

    kill() {
        if (this.moveState.can('die')) {
            this.moveState.attemptTransition('die')
            this.animState.attemptTransition('die')
            this.emit('died')
            this.scene.updateLives(0)
            this.setTint(0xff4f4f)
        }
    }
    isDead() {
        return this.moveState.is('dead')
    }

    setIsKillingEnemy = (isKillingEnemy) => {
        this.isKillingEnemy = isKillingEnemy
    }

    handleTrampolineCollision = (_, trampoline) => {
        if (!trampoline.body.touching.up) return;
        if (this.moveState.is('trampolinejumping')) return;
        // console.log('handle trampoline jump!')
        this.setDidTrampolineJump()
        trampoline.anims.play('trampoline-active', true)
    }
    handleCollectableOverlap = (_, collectable) => {
        // console.log('overlap ',collectable)
        collectable.disableBody(true)
        collectable.destroy()
        let textureKey = collectable.texture.key
        if (textureKey === 'life') {
            this.scene.updateLives(++this.lives)
        }

        if(textureKey !== 'life')
        {
            this.a.f(textureKey, 1)
        }

        // console.log("score: " + scoreByItems[textureKey] + " = " + textureKey)
        //
        // console.log(this.a.e)

        this.scene.updateCat(this.a.e, this.ts)

        this.scene.incrementScore(scoreByItems[textureKey])
        this.scene.collectSound.play()
    }

    takeHit = () => {
        if (this.hasBeenHit) return;
        this.hasBeenHit = true

        if (--this.lives <= 0) {
            this.kill()
            return;
        }
        this.scene.updateLives(this.lives)

        this.body.allowDrag = false
        this.body.setVelocity(this.flipX ? 400 : -400, -800)

        const hitAnim = this.playDamageTween()
        this.scene.hitSound.play()

        this.scene.time.delayedCall(1000, () => {
            try {
                this.body.allowDrag = true
                this.hasBeenHit = false;
                hitAnim.stop()
                this.setAlpha(1)
            } catch (e) {
                console.warn(e)
            }
        })
    }

    playDamageTween = () => {
        return this.scene.tweens.add({
            targets: this,
            duration: 100,
            repeat: -1,
            alpha: 0.10,
            yoyo: true
        })
    }

    handleEnemyCollision = (_, enemy) => {
        // if (enemy.enemyType === 'MovingPlatform') {
        //     console.log(enemy.enemyType, 'Player')
        // }
        // if (enemy.body.touching.up && enemy.kill()) {
        //     if (!this.isKillingEnemy) {
        //         this.setIsKillingEnemy(true)
        //         this.setDidTrampolineJump()
        //         setTimeout(() => {
        //             this && 
        //             this.setIsKillingEnemy && 
        //             this.setIsKillingEnemy(false)
        //         }, 100)
        //     }
        // } else {
        //     this.takeHit()
        // }

        if (enemy.canBeKilled() && 
            enemy.body.touching.up && enemy.kill()) {
            if (!this.isKillingEnemy) {
                this.setIsKillingEnemy(true)
                this.setDidTrampolineJump()
                setTimeout(() => {
                    try {
                        if (this && typeof this.setIsKillingEnemy === 'function') {
                            this.setIsKillingEnemy(false)
                        }
                    } catch (e) {
                        console.warn(e)
                    }
                    // this &&
                    // this.setIsKillingEnemy &&
                    // this.setIsKillingEnemy(false)
                }, 100)
            }
        } else if (enemy.canKill()) {
            this.takeHit()
        }
    }

    preUpdate(time, delta) {
        super.preUpdate(time, delta)

        this.frameTime += (delta || 0)
        if (this.frameTime <= 16.5) {
            return;
        }
        this.frameTime = 0

        this.input.didPressJump = !this.scene.hasOverlappedFlag && !this.isDead() && (Phaser.Input.Keyboard.JustDown(this.keys.up) || window.mobileGameController.getJustDown('UP'))
        this.input.didTrampolineJump = !this.scene.hasOverlappedFlag && !this.isDead() && this.getDidTrampolineJump()

        if (!this.scene.hasOverlappedFlag && !this.isDead() && (this.keys.left.isDown || window.mobileGameController.getIsDown('LEFT'))) {
            this.body.setAccelerationX(-2000)
            this.setFlipX(true)
            this.body.offset.x = 64
        } else if (!this.scene.hasOverlappedFlag && !this.isDead() && (this.keys.right.isDown || window.mobileGameController.getIsDown('RIGHT'))) {
            this.body.setAccelerationX(2000)
            this.setFlipX(false)
            this.body.offset.x = 60
        } else {
            this.body.setAccelerationX(0)
        }

        // if (this.moveState.is('jumping') || this.moveState.is('flipping')) {
        //     if (!(this.keys.up.isDown || window.mobileGameController.getIsDown('UP')) && this.body.velocity.y < -150) {
        //         this.body.setVelocityY(-150)
        //     }
        // }

        for (const t of this.moveState.transitions()) {
            if (t in this.movePredicates && this.movePredicates[t]()) {
                this.moveState.attemptTransition(t)
                break;
            }
        }

        for (const t of this.animState.transitions()) {
            if (t in this.animPredicates && this.animPredicates[t]()) {
                this.animState.attemptTransition(t)
                break;
            }
        }
    }
}

export default Hero